$(window).on("load", function () {
	const body = $("body");
	const toggle = $("#menu-toggle");
	const nav = $("#main-nav");
	const header = $("#masthead");

	toggle.on("click", function () {
		if (toggle.hasClass("open")) {
			header.removeClass("open");
			toggle.removeClass("open");
			nav.removeClass("toggle-open");
			nav.parent().removeClass("toggle-open");
			body.removeClass("fixed");
			toggle.attr("aria-expanded", "false");
		} else {
			body.addClass("fixed");
			header.addClass("open");
			toggle.addClass("open");
			nav.addClass("toggle-open");
			nav.parent().addClass("toggle-open");
			toggle.attr("aria-expanded", "true");
		}
	});

});
